// extracted by mini-css-extract-plugin
export default {"cls1":"DisclosureMessage-Container_cls1__iqQI8","cls2":"DisclosureMessage-Container_cls2__jdG28 DisclosureMessage-Container_cls1__iqQI8"};